export default __webpack_public_path__ + "media/img_01/800-463bc382.jpg";